import React from 'react';
import { DocumentType } from '../../models/documentType.model';
import DocumentListView from '../documents/document-list-view/document-list-view';

export default function MyInvoicesContainer() {
    return (
        <React.Fragment>
            <DocumentListView
                fetchPerUserOnly={true}
                documentTypeCodes={[DocumentType.InvoiceProforma, DocumentType.CreditNote]}
            />
        </React.Fragment>
    );
}
